<template>
    <div id="classlist">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <div class="header">
                <p>班级管理</p>
                <span @click="add_class">添加班级</span>
            </div>
            <div class="school_list" v-if="school_list">
                <div class="school_item" v-for="(item,index) in school_list" :key="index">
                    <div class="title flex ac">
                        <img src="./img/icon_school.png" class="icon_school"/>
                        <p>{{item.school_name }}</p>
                    </div>
                    <div class="unit_list">
                        <div class="unit_item flex jb ac" v-for="(item2,index2) in item.units" :key="index2">
                            <div class="class_name">{{item2.unit_name }}</div>
                            <i class="sub" :class="'sid'+item2.sid">{{(item2.sid == 21|| item2.sid == 22)?'数': item2.sid == 51 ? '语': item2.sid == 91 ? '英': item2.sid == 11 ? '书': item2.sid == 12 ? '编': item2.sid == 13 ? '模' : '其' }}</i>
                            <div class="code flex ac" @click="share(item,item2)">
                                <img src="./img/icon_code.png" class="icon_code" />
                                <p>分享班级链接</p>
                            </div>
                            <div class="right flex" @click="detail(item2)">
                                <img src="./img/icon_right.png" class="icon_right" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <noResouse v-else></noResouse>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
    import loadings from "COMPONENTS/base/loadingS.vue";
    import noResouse from 'COMPONENTS/noResouse.vue';
    export default {
        components: {
            loadings,
            noResouse,
        },
        data() {
            return {
                loading: true,
                school_list:[],
            }
        },
        created() {
            this.getList()
            localStorage.removeItem('areaInfo')
            localStorage.removeItem('schoolInfo')
        },
      
        methods: {
            //添加班级
            add_class() {
                this.$router.push('/classlist/add')
            },
            //获取学校班级列表
            getList(){
                this.$http.post(API_URL_BASE_API + '/unit/region/class_list/').then(res=>{
                    this.loading=false
                    if(res.data.response=='ok'){
                        this.school_list=res.data.data.school_list
                    }else{
                        layer.tips(res.data.message)
                    }
                })
            },
            //分享班级链接
            share(item,item2){
                let that=this
                this.$http.post(API_URL_BASE_API + '/unit/region/teacher/share/link',{
                    unit_id:item2.unit_class_id,
                    subject_id:item2.sid,
                }).then(res => {
                    if (res.data.response == 'ok') {
                        let content = item.school_name + item2.unit_name + ',点击链接，加入老师班级：' + res.data.data[0].url
                        layer.alert('将链接粘贴并发送到对应的班级群，家长点击链接即可。', 'tea', function (index) {
                            layer.close(index)
                            that.copyText(content)
                        }, '分享链接复制成功')
                    } else {
                        layer.tips(res.data.message)
                    }
                })
            },
            copyText (text) {
                const input = document.createElement('input');
                input.setAttribute('readonly', 'readonly');
                input.setAttribute('value', text);
                document.body.appendChild(input);
                input.setSelectionRange(0, 9999);
                input.select();
                document.execCommand('copy');
                document.body.removeChild(input);
            },
            //查看班级详情
            detail(item){
                this.$router.push(`/classlist/detail/${item.sid}/${item.unit_class_id}?unit_name=${item.unit_name}`)
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.flex{
    display: flex;
}
.jb{
    justify-content: space-between;
}
.ac{
    align-items: center;
}
#classlist{
    padding-top: $h-header;
}
.header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 8;
    height: $h-header;
    line-height: $h-header;
    color: #fff;
    font-size: 34px / $ppr;
    text-align: center;
    background: #5e89ef;

    span {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        padding: 0 24px/$ppr;
        height: $h-header;
        line-height: $h-header;
        font-size: 28px/$ppr;
        opacity: 0.8;
    }
}
.school_list{
    padding: 20px/$ppr;
    .school_item{
        margin-bottom: 20px/$ppr;
        .title{
            padding: 25px/$ppr;
            border-radius: 20px/$ppr 20px/$ppr 0 0;
            background:#DFE7FC;
            color: #5e89ef;
            font-size: 28px/$ppr;
            .icon_school{
                width: 42px/$ppr;
                height: 41px/$ppr;
                margin-right: 15px/$ppr;
            }
        }
        .unit_list{
            background:#fff;
            padding: 0 36px/$ppr;
            border-radius: 0 0 20px/$ppr 20px/$ppr;
            .unit_item{
                padding: 10px/$ppr 0;
                border-bottom:1px/$ppr solid #eaeaea;
                &:last-child{
                    border-bottom: 0;
                }
                .sub{
                    width: 32px/$ppr;
                    height: 32px/$ppr;
                    text-align: center;
                    line-height: 36px/$ppr;
                    border-radius: 6px/$ppr;
                    font-size: 20px/$ppr;
                    margin: 0 50px/$ppr 0 30px/$ppr;
                    border:2px/$ppr solid #eaeaea;
                    &.sid21,&.sid22{
                        color: #5e89ef;
                        border:2px/$ppr solid #5e89ef;
                    }
                    &.sid51{
                        color: #FDC43C;
                        border:2px/$ppr solid #FDC43C;
                    }
                    &.sid91{
                        color: #79D946;
                        border:2px/$ppr solid #79D946;
                    }
                    &.sid11{
                        color: #FF8575;
                        border:2px/$ppr solid #FF8575;
                    }
                    &.sid12{
                        color: #A182EA;
                        border:2px/$ppr solid #A182EA;
                    }
                    &.sid13{
                        color: #3CC6E1;
                        border:2px/$ppr solid #3CC6E1;
                    }
                }
                .code{
                    .icon_code{
                        width: 24px/$ppr;
                        height: 24px/$ppr;
                        margin-right: 10px/$ppr;
                    }
                    p{
                        color: #999;
                        font-size: 24px/$ppr;
                    }
                }
                .right{
                    padding: 20px/$ppr;
                    flex: 1;
                    justify-content: end;
                    justify-content: flex-end;
                    .icon_right{
                        width: 12px/$ppr;
                        height: 24px/$ppr;
                    }
                }
            }
        }
    }
}
</style>